import React, { useState } from "react";
import { Disclosure } from "@headlessui/react";
import { ChevronUpIcon } from "@heroicons/react/solid";
const services = [
  {
    title: "Smart Contracts",
    content: "We specialize in developing and deploying secure smart contracts with comprehensive support throughout the entire process. Our team handles everything from initial concept to final deployment, offering you a complete smart contract service package."
  },
  {
    title: "Meme Deployment", 
    content: "We manage successful meme token deployments with all the necessary components for viral growth. Our service covers everything from token creation to marketing strategy, providing you with a full meme deployment solution."
  },
  {
    title: "Security Audits",
    content: "We conduct thorough security audits with complete vulnerability assessment and testing. Our comprehensive audit service identifies potential risks and provides detailed recommendations to secure your blockchain projects."
  },
  {
    title: "NFT Mint",
    content: "We create and launch NFT collections with end-to-end minting solutions. Our NFT minting service includes everything from artwork preparation to smart contract deployment and marketplace integration."
  },
  {
    title: "dApp Development",
    content: "We build decentralized applications with full-stack blockchain integration. Our dApp development service covers everything from UI/UX design to smart contract backend and wallet connectivity."
  },
  {
    title: "Token Creation",
    content: "We develop custom tokens with complete tokenomics design and deployment. Our token creation service includes everything from economic modeling to multi-chain deployment and liquidity provisioning."
  }
];
const Web3Services = () => {
  return (
    <div className="py-16 px-6 max-w-4xl mx-auto">
      <h1 className="text-4xl font-bold mb-6 text-blue-700">
        Web3 & Degen Services
      </h1>

      <p className="text-white-700 mb-10 text-lg">
        We help launch decentralized projects on Ethereum, Solana, Sui, and Bitcoin.  
        Our team builds smart contracts, creates NFT marketplaces, and consults on tokenomics and DAO structures.
      </p>

      {/* Drawer Section */}
      <div className="space-y-4">
        {services.map((service, idx) => (
          <Disclosure key={idx}>
            {({ open }) => (
              <>
                <Disclosure.Button className="flex w-full justify-between rounded-lg bg-purple-100 px-4 py-2 text-left text-purple-900 hover:bg-purple-200">
                  <span>{service.title}</span>
                  <ChevronUpIcon
                    className={`${
                      open ? "rotate-180 transform" : ""
                    } h-5 w-5 text-purple-500`}
                  />
                </Disclosure.Button>
                <Disclosure.Panel className="px-4 pt-4 pb-2 text-gray-700">
                  {service.content}
                </Disclosure.Panel>
              </>
            )}
          </Disclosure>
        ))}
      </div>
    </div>
  );
};

export default Web3Services;
